// src/features/collaboration/yjs/transport/create-hocuspocus-transport.ts
import { environment } from "@environment";
import { HocuspocusProvider } from "@hocuspocus/provider";
import type * as Y from "yjs";
import { mapHocuspocusStatus } from "./map-hocuspocus-status";
import type { YjsTransport } from "./types";

interface Options {
  doc: Y.Doc;
  roomId: string;
  getToken: (room: string) => Promise<string>;
}

export const createHocuspocusTransport = ({
  doc,
  roomId,
  getToken,
}: Options) => {
  let connected = false;
  const provider = new HocuspocusProvider({
    url: environment.hocuspocusUrl,
    name: roomId,
    document: doc,
    token: () => getToken(roomId),
  });
  provider.on(
    "status",
    ({ status }: { status: "connecting" | "connected" | "disconnected" }) => {
      connected = status === "connected";
    },
  );

  const transport: YjsTransport = {
    onSync: (cb) => provider.on("synced", () => cb(true)),
    onStatus: (cb) =>
      provider.on(
        "status",
        ({ status }: { status: "connecting" | "connected" | "disconnected" }) =>
          cb(mapHocuspocusStatus(status)),
      ),
    // Converged = connected AND server has acknowledged all local updates.
    // `hasUnsyncedChanges` (v4 boolean getter) is true while local updates are
    // still pending. Confirmed against @hocuspocus/provider@4.3.0.
    isConverged: () => connected && !provider.hasUnsyncedChanges,
    destroy: () => provider.destroy(),
  };
  return { transport, provider };
};
